import { css } from 'styled-components';
import { PaymentPlansProps } from './models';

export const PaymentPlans = css<PaymentPlansProps>(({ theme }) => {
  return css`
    width: 100%;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `;
});
